import { Skeleton } from "primereact/skeleton"

const DynamicPageSkeleton = () => {
    return (
        <div className="page-content">
            <div className="row mt-3">
                <div className="col-12 mb-3">
                    <Skeleton height={50} width="100%" />
                </div>
                <div className="col-12 mb-3">
                    <Skeleton height={50} width={300} />
                </div>
                <div className="col-12 mb-3">
                    <Skeleton height="70px" width="100%" />
                </div>
                <div className="col-12">
                    <Skeleton height="400px" width="100%" />
                </div>
            </div>
        </div>
    )
}

export default DynamicPageSkeleton